import React from 'react';
import makeStyles from '@mui/styles/makeStyles';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import SettingsCard from "./settings-card";

const DashboardView = () => {
  const classes   = buildStyles();

  return (
    <Grid id="data-view" container className={classes.root} spacing={2}>
      <Grid item xs={12}>        
        <Typography variant="h5" color="primary" className={classes.title}>Admin Dashboard</Typography>
      </Grid>
      <Grid item xs={6}>
        <SettingsCard />
      </Grid>
    </Grid>
  );
}

export default DashboardView;

const buildStyles   = makeStyles(theme => ({
  root  : {
    padding     : theme.spacing(1),
  },
  title   : {
    fontSize    : 22,
    fontWeight  : 500,
    // textAlign   : "center",
    marginBottom: theme.spacing(1),
  },
  subTitle  : {
    fontSize  : 17,
    fontWeight: 500,
    // textAlign : "center",
    marginBottom  : theme.spacing(3),
    color     : theme.palette.grey[800],
  },
}));